import type { ReactNode } from 'react'
import { FlatCardsContext } from '@/components/Card'
import { TableTab, TableTabs } from '@/components/DataTable/TableView'
import styles from './JobSections.module.css'
import type {
  JobSection,
  JobSectionTab,
} from '@/features/jobs/details/JobDetailsViewModel'

export interface JobSectionsProps {
  tabs: JobSectionTab[]
  current: JobSection
  onSelectSection: (section: JobSection) => unknown
  modals?: ReactNode
  children: ReactNode
}

/**
 * The job's sections as tabs, and the current one's content.
 */
export function JobSections({
  tabs,
  current,
  onSelectSection,
  modals,
  children,
}: JobSectionsProps) {
  return (
    <FlatCardsContext.Provider value>
      <div className={styles.root}>
        <TableTabs aria-label="Job sections">
          {tabs.map((tab) => (
            <TableTab
              key={tab.id}
              isSelected={current === tab.id}
              onPress={() => onSelectSection(tab.id)}
              testId={`job-section-${tab.id}`}
            >
              {tab.label}
              {tab.count !== undefined && (
                <span className={styles.count}>{tab.count}</span>
              )}
            </TableTab>
          ))}
        </TableTabs>
        <section className={styles.pane} data-test={`job-pane-${current}`}>
          {children}
        </section>
      </div>
      {modals}
    </FlatCardsContext.Provider>
  )
}
